// extracted by mini-css-extract-plugin
module.exports = {"tabsCon":"index_tabsCon__JRQe2","tabsConBox":"index_tabsConBox__7O8z2"};